import React from 'react';
import Tooltip from '../Tooltip/Tooltip';
import { Info } from 'lucide-react';

interface InfoHintProps {
  content: string;
  className?: string;
  iconClassName?: string;
}

const InfoHint: React.FC<InfoHintProps> = ({ content, iconClassName }) => {
  return (
    <Tooltip content={content}>
      <Info className={`h-5 w-5 text-gray-500 ${iconClassName || ''}`} />
    </Tooltip>
  );
};

export default InfoHint;


